import styled from 'styled-components'
import { Text } from '~/components/core'

export const StyledTitleText = styled(Text)`
  max-width: 236px;
  text-overflow: ellipsis;
`

export const StyledSubtitleText = styled(Text)`
  max-width: 286px;
  text-overflow: ellipsis;
`

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 240px;
  > p {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > p {
    white-space: pre;
  }
`
